export const NOT_STARTED_YET = 'NOT_STARTED_YET';
export const CONNECTED = 'CONNECTED';
export const DISCONNECTED = 'DISCONNECTED';